import React, { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { Trans, useTranslation } from 'react-i18next';
import Card from 'react-bulma-components/lib/components/card';
import Button from 'components/UIComponents/Button';
import {
  addCookieScript,
  CookieConsentValue,
  cookieOptions,
  COOKIE_CONSENT_AGREED_NAME,
  COOKIE_CONSENT_EXPIRATION_MS,
  COOKIE_NAME_LIST,
  removeCookieScript,
} from 'utils/cookieUtils';

import './style.scss';

const CookieNotification = ({ show, onShow }) => {
  const { t } = useTranslation();

  const [cookies, setCookie, removeCookie] = useCookies([
    ...COOKIE_NAME_LIST,
    COOKIE_CONSENT_AGREED_NAME,
  ]);

  const consentAgreedCookieValue = cookies[COOKIE_CONSENT_AGREED_NAME];
  const consentCookieIsSet = consentAgreedCookieValue !== undefined;

  const showNotification = !consentCookieIsSet || show === true;

  const cookieNotificationClassName = [
    'eu-cookie-compliance-notification',
    !showNotification ? 'hidden' : '',
  ]
    .join(' ')
    .trim();

  const removeAllCookies = () => {
    COOKIE_NAME_LIST.forEach(cookieName => {
      removeCookie(cookieName, cookieOptions);
    });
  };

  useEffect(() => {
    if (consentAgreedCookieValue === CookieConsentValue.accept) {
      addCookieScript();
    }
  }, [consentAgreedCookieValue]);

  useEffect(() => {
    if (
      !consentCookieIsSet ||
      consentAgreedCookieValue === CookieConsentValue.reject
    ) {
      removeAllCookies();
    }
    // eslint-disable-next-line
  }, [consentCookieIsSet, consentAgreedCookieValue]);

  const handleAcceptCookies = () => {
    onShow(false);
    setCookie(COOKIE_CONSENT_AGREED_NAME, CookieConsentValue.accept, {
      path: '/',
      sameSite: 'strict',
      expires: new Date(COOKIE_CONSENT_EXPIRATION_MS),
    });
    if (consentCookieIsSet) {
      window.location.reload();
    }
  };

  const handleRejectCookies = () => {
    onShow(false);
    setCookie(COOKIE_CONSENT_AGREED_NAME, CookieConsentValue.reject, {
      path: '/',
      sameSite: 'strict',
      expires: new Date(COOKIE_CONSENT_EXPIRATION_MS),
    });
    removeAllCookies();
    removeCookieScript();
    if (consentCookieIsSet) {
      window.location.reload();
    }
  };

  return (
    <div
      className={cookieNotificationClassName}
      role="alertdialog"
      aria-labelledby="popup-text"
      aria-hidden={Boolean(!showNotification)}
    >
      <Card>
        <Card.Content id="popup-text">
          <h2 className="heading">
            {t('datagate.external.cookie.compliance.heading')}
          </h2>
          <div className="message">
            <p>
              <Trans
                components={{
                  cookieLink: (
                    <a
                      href={t('datagate.external.cookie.compliance.cookieLink')}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {' '}
                    </a>
                  ),
                }}
              >
                datagate.external.cookie.compliance.message
              </Trans>
            </p>
          </div>
          <div className="actions">
            <Button outlined color="primary" onClick={handleRejectCookies}>
              {t('datagate.external.cookie.compliance.reject')}
            </Button>
            <Button color="primary" onClick={handleAcceptCookies}>
              {t('datagate.external.cookie.compliance.accept')}
            </Button>
          </div>
        </Card.Content>
      </Card>
    </div>
  );
};

export default CookieNotification;
